import { FC } from 'react'
import styled from 'styled-components'

const Text = styled.p`
  margin: 0;
`

interface Props {
  description: string
}

const Description: FC<Props> = ({ description }) => {
  return <Text>{description}</Text>
}

export default Description
